module.exports = __webpack_public_path__ + "img/achievement-course1.4f5bba7b.png";